import { useHttpClient } from '../../hooks/useHttpClient';
import { useDispatch } from 'react-redux';
import { selectLeads, setLeads } from './leadsSlice';
import { store } from '..';

// Custom hook to be used inside React components
export const useDeleteLead = () => {
  const { httpClient } = useHttpClient();
  const dispatch = useDispatch();

  const deleteLead = async (email) => {
    try {
      const response = await httpClient.delete(`/${email}/delete`);

      // Update Redux store to reflect the deleted lead
      if (response.data) {
        const currentLeads = selectLeads(store.getState());
        const updatedLeads = { ...currentLeads };
        updatedLeads.power = updatedLeads.power?.filter(lead => lead.contact.email !== email);
        updatedLeads.sail = updatedLeads.sail?.filter(lead => lead.contact.email !== email);

        dispatch(setLeads(updatedLeads));
      }

      return response.data;
    } catch (error) {
      throw new Error(`Failed to delete lead: ${error.message}`);
    }
  };

  return deleteLead;
};
